import styled from 'styled-components';

export const ErrorMessageStyled = styled.div`
  padding: 0 40px;
  margin: 0 auto;
`;
